import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["CosmeticBadgeRow"] */ "/vercel/path0/src/components/title/CosmeticBadgeRow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TitleGlance"] */ "/vercel/path0/src/components/title/TitleGlance.tsx");
